// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Cart as CoveoCart } from "@coveo/headless/commerce";
import {
    ApiHandlerDiscreteParameter,
    HasOnError,
} from "@insite/client-framework/HandlerCreator";
import {
    Cart,
    CartResult,
    UpdateCartApiParameter,
} from "@insite/client-framework/Services/CartService";
import { CartModel } from "@insite/client-framework/Types/ApiModels";

interface PlaceOrderParameter {
    paymentMethod: string;
    poNumber: string;
    vatNumber?: string;
    saveCard: boolean;
    cardHolderName: string;
    cardNumber: string;
    cardType: string;
    expirationMonth: number;
    expirationYear: number;
    securityCode: string;
    useBillingAddress: boolean;
    address1: string;
    countryId: string;
    stateId: string;
    city: string;
    postalCode: string;
    onSuccess?: (cartId: string) => void;
    payPalToken?: string;
    payPalPayerId?: string;
    accountHolderName?: string;
    accountNumber?: string;
    routingNumber?: string;
    cart?: CartModel;
}

type HandlerType = ApiHandlerDiscreteParameter<
    PlaceOrderParameter & HasOnError,
    UpdateCartApiParameter,
    CartResult,
    {
        cartToUpdate: Cart;
    }
>;
const CoveoPurchaseChainTap = (coveoCart: CoveoCart): HandlerType => props => {
    // console.log("PURCHASE EVENT >>", coveoCart, props);
    coveoCart.purchase({
        id: props.apiResult.cart.id,
        revenue: props.apiResult.cart.finalGrandTotal || 0
    });
};

export default CoveoPurchaseChainTap;